import React from 'react';
import {
	FunctionField,
	TextField,
	TextInput,
} from 'react-admin';
import ReactDOM from 'react-dom';
import { isNullUndEmpty } from 'utils/general';

import { EditForm } from './EditableField';
import { useEditableFieldStyles } from './EditableField';

export const EditableGridCellField = React.memo(({ editable, title="Double click to edit", EditInputComponent = TextInput, EditFieldComponent = TextField, style={}, changesFieldColor = 'orange', checkIsDisabled, editLabel, ...props }) => {
	const isEditable = editable && (checkIsDisabled ? !checkIsDisabled(props.record) : true)							
	return (
		<EditGridCellPopup
			editable={isEditable}
			source={props.source}
			resource={props.resource}
			record={props.record}
			basePath={props.basePath}
			updateSelectedIds={props.updateSelectedIds}
			updateSelectedFields={props.updateSelectedFields}
			openPopupExtraCondition={props.openPopupExtraCondition}
			edit={(
				<EditInputComponent 
					{...props}
					autoFocus
					label={editLabel ? editLabel : props.label}
					source={props.source} 
					reference={props.reference} 
					validate={props.validate} 
					min={props.min} 
					format={props.format}
					parse={props.parse}
					choices={props.choices}	
					link={false}					  
				/>
						   
			)}
			render={({ openPopup, className }) => (
				<FunctionField
					render={r => (
						<div 
							title={title} 
							className={className} 
							onDoubleClick={openPopup}
							style={(props.selectedFields[props.record.id] || {}) &&  
								Object.keys(props.selectedFields[props.record.id] || {}).indexOf(props.source) !== -1
								? { ...style, backgroundColor: changesFieldColor || 'orange' } 
								: style
							}
						>
							{!isNullUndEmpty(r[props.source]) ? 
								<EditFieldComponent 
									{...props}
									link={false}					  
									source={props.source} 
									record={{...r, [props.source]: (props.formatField ? props.formatField(r[props.source]) : r[props.source])}} 
								/>
							 : '\u00A0'}
						</div>
					)}
				/>
			)}
		/>
	);
}, (_old, _new) => _old.editable === _new.editable && _old.record.id === _new.record.id && _old.record[_old.source] === _new.record[_new.source]);

EditableGridCellField.defaultProps = {
    addLabel: true,
};


const EditGridCellPopup = ({ 
	render, 
	edit, 
	editable, 
	updateType, 
	prepareValues = v => v, 
	additionalParams = [], 
	openPopupExtraCondition = true,
	...props 
}) => {

	const classes = useEditableFieldStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = (e) => {
		setAnchorEl(null);
	};
	const open = Boolean(anchorEl);

	const handleSubmit = async values => {
		props.record[props.source] = values[props.source];
		props.updateSelectedIds(props.record.id);
		props.updateSelectedFields(props.record, props.source);
		setAnchorEl(false)
	};

	return (
		<React.Fragment>
			{openPopupExtraCondition && open && ReactDOM.createPortal((
				<EditForm anchorEl={anchorEl} handleSubmit={handleSubmit} handleClose={handleClose} edit={edit} {...props} />
			), document.body)}
			{editable === false ? render({}) : render({ openPopup: handleOpen, className: classes.root })}
		</React.Fragment>
	);
};
